/* eslint-disable no-unused-vars */
import * as React from "react";
import Typography from "@mui/material/Typography";
import { connect, useDispatch, useSelector } from "react-redux";
import SearchReport from "../SearchReport";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { Container,  InputLabel } from "@mui/material";
import axios from "axios";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import "./styleAdd.css";
import { CLIENTES_REDUX_REPORT } from "../../../redux/constanst";
import fetchCall from "../models/fetch.mjs";
import LoadScreen from "../loadScreen";

import TextField from "@mui/material/TextField";
import {
  forMiles,
  forMilesUf,
  handleUpdateNumberUF,
  hosting,
  mapStateToProps,
} from "../models/buscar";
import { useEffect } from "react";
function AdmGeneradorReporte(props) {
  const { clientesReduxReport } = useSelector((state) => state.userState);
  const arrSuma = [];
  const arrSumaLlamadas = [];
  
  const arrSumaLlamadas2 = [];

  const [uf, setUf] = React.useState(0);
  const [unaVez] = React.useState(1);

  const [ufs, setUfS] = React.useState(0);
  const [valor, setValor] = React.useState({});
  const [yearDesde, setYearDesde] = React.useState({
    mes: new Date().getMonth(),
    year: new Date().getFullYear(),
  });
  const [yearDesdeS, setYearDesdeS] = React.useState({});

  const [sumaTotal, setSumaTotal] = React.useState(0);

  const [sumaTotalLlamadas, setSumaTotalLlamadas] = React.useState(0);
  
  const [sumaTotalLlamadas2, setSumaTotalLlamadas2] = React.useState(0);
  const dispatch = useDispatch();

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));
  const StyledTableCell2 = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));

  const fnSumar = () => {
    var suma = arrSuma.reduce((a, b) => parseFloat(a) + parseFloat(b), 0);
    return suma;
  };

  const fnSumarLlamadas = () => {
    var suma = arrSumaLlamadas.reduce(
      (a, b) => parseFloat(a) + parseFloat(b),
      0
    );
    return suma;
  };

  const fnSumarLlamadas2 = () => {
    var suma = arrSumaLlamadas2.reduce(
      (a, b) => parseFloat(a) + parseFloat(b),
      0
    );
    return suma;
  };

  React.useEffect(() => {
    setSumaTotal(fnSumar());

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [arrSuma]);
  React.useEffect(() => {
    setSumaTotalLlamadas(fnSumarLlamadas());

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [arrSumaLlamadas]);
  React.useEffect(() => {
    setSumaTotalLlamadas2(fnSumarLlamadas2());

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [arrSumaLlamadas2]);

  React.useEffect(() => {
    axios
      .get(`${hosting}/mimegacall/api/select_usuarios_empresa.php`)
      .then((response) => {
        const arr = Object.values(response.data);
        dispatch({ type: CLIENTES_REDUX_REPORT, clientesReduxReport: arr });
        setNames(arr);
      })
      .catch(function (error) {});

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const anexosAmbos2 = [
    {
      item: 0,
      name: "Generador de Reportes",
    },
  ];
  const [names, setNames] = React.useState(clientesReduxReport);

  const [rows, setRows] = React.useState([]);

  const [open, setOpen] = React.useState(false);
  const [rut, setRut] = React.useState(false);

  const [tarifas, setTarifas] = React.useState(false);

  const [empresa, setEmpresa] = React.useState(false);

  const [empresaS, setEmpresaS] = React.useState(false);
  const [anexosConectados, setAnexosConetados] = React.useState(0);

  const [costoTotal, setCostoTotal] = React.useState([]);
  const mesArray = [
    { name: "Enero", value: 1 },
    { name: "Febrero", value: 2 },
    { name: "Marzo", value: 3 },
    { name: "Abril", value: 4 },
    { name: "Mayo", value: 5 },
    { name: "Junio", value: 6 },
    { name: "Julio", value: 7 },
    { name: "Agosto", value: 8 },
    { name: "Septiembre", value: 9 },
    { name: "Octubre", value: 10 },
    { name: "Noviembre", value: 11 },
    { name: "Diciembre", value: 12 },
  ];

  const yearArray = [
    { name: "2022", value: 2022 },
    { name: "2023", value: 2023 },
    { name: "2024", value: 2024 },
  ];
  const handleChange = async (event) => {
    setOpen(true);
    setValor({});
    const busqueda = clientesReduxReport.filter(
      (data) => data.name === empresa
    );

    setRut(busqueda[0].rut);
    const listaGrupo = busqueda[0].sucursales.map((item) => {
      /* const formData = new FormData();
      const url = `${hosting}/mimegacall/api/salientes_total.php`;
      formData.append("diaInicio", 1);
      formData.append("mesInicio", yearDesde.mes);
      formData.append(
        "diaFinal",
        new Date(yearDesde.year, yearDesde.mes, 0).getDate()
      );
      formData.append("mesFinal", yearDesde.mes);
      formData.append("yearInicio", yearDesde.year);
      formData.append("yearFinal", yearDesde.year);
      formData.append("anexos", item.anexos);
      const datosResult = await axios.post(`${url}`, formData)

      console.log("Respuesta prueba", await datosResult.data);
 */
      return item.anexos;
    });

    busqueda[0].sucursales.map((item) => {
      /* const formData = new FormData();
      const url = `${hosting}/mimegacall/api/salientes_total.php`;
      formData.append("diaInicio", 1);
      formData.append("mesInicio", yearDesde.mes);
      formData.append(
        "diaFinal",
        new Date(yearDesde.year, yearDesde.mes, 0).getDate()
      );
      formData.append("mesFinal", yearDesde.mes);
      formData.append("yearInicio", yearDesde.year);
      formData.append("yearFinal", yearDesde.year);
      formData.append("anexos", item.anexos);
      const datosResult = await axios.post(`${url}`, formData)

      console.log("Respuesta prueba", await datosResult.data);
 */
      return item.anexos;
    });
    console.log(busqueda[0]);
    const datosResult = fetchCall(
      "salientes_total",
      0,
      1,
      yearDesde.mes,
      new Date(yearDesde.year, yearDesde.mes, 0).getDate(),
      yearDesde.mes,
      yearDesde.year,
      yearDesde.year,
      listaGrupo.flat()
    );
    axios
      .get(
        `${hosting}/mimegacall/api/select_tarifa_servicios.php?id_user=${busqueda[0].id}`
      )
      .then((response) => {
        if (response.data.type === "error") {
          setTarifas([]);
          /*  Swal.fire(response.data.mensaje, ``, `${response.data.type}`).then(
            (result) => {
              setCostoTotal(0);
              setEmpresaS([]);
              setYearDesdeS(0);
              setUfS(0);
              asignarValores([]);
              setTarifas([]);
              return;
            }
          ); */
        } else {
          setTarifas(response.data);
        }
      });
    axios
      .get(
        `${hosting}/mimegacall/api/select_anexos_all_reporte.php?id=${busqueda[0].id}`
      )
      .then((response) => {
        setAnexosConetados(Object.values(response.data));
      })
      .catch(function (error) {
        console.log(error);
      });

    Promise.all([datosResult]).then((res) => {
      setCostoTotal(res);
      setEmpresaS(empresa);
      setYearDesdeS(yearDesde);
      setUfS(uf);
      setOpen(false);
      asignarValores(busqueda[0].sucursales, res);
    });
  };

  //

  /* const busqueda = async (anexos2, index) => {
    const formData = new FormData();
    formData.append("fechaDesde", yearDesde);
    formData.append("fechaFinal", yearHasta);
    formData.append("anexos", JSON.stringify(anexos2));
    const resp = await fetch(`${hosting}/mimegacall/api/salientes.php`, {
      headers: {
        Accept: "application/json",
      },
      method: "POST",
      body: formData,
    }).then((response) => {
      return response.json();
    }); 

    setValor({...valor, 
        [index]: resp.costoTotal}) 
    return resp;
  }; */
  const asignarValores = (rowsFrom, costoTotal) => {
    const newRows = rowsFrom.map((row) => {
      const valoresNetos = row.anexos.map((anexo) => {
        const valor = Object.values(costoTotal[0]).find((data) => {
          return data.chan1 === anexo ? data : 0;
        });
        return valor;
      });
      let total = 0;
      let total_llamadas = 0;
      valoresNetos.map((data2) => {
        return data2
          ? ((total += parseFloat(data2.cost)),
            (total_llamadas += parseInt(data2.total_llamadas)))
          : 0;
      });
      row["cost"] = total;
      row["total_llamadas"] = total_llamadas;

      return row;
    });
    setRows(newRows);
  };
  useEffect(() => {
    if (uf <= 0) {
      valorUF();
    }
  }, []);

  const valorUF = async () => {
    const valor = await axios.get("https://mindicador.cl/api/uf");
    setUf(Math.ceil(valor.data.serie[0].valor));
  };

  return (
    <div key="todo_aqui">
      {anexosAmbos2.map((solicitud, index) => {
        return (
          <>
            <Typography
              key={index}
              style={{
                marginLeft: 20,
                fontSize: 18,
                alignItems: "left",
                justifyContent: "left",
                textAlign: "left",
                borderRadius: 10,
                padding: 5,
                fontWeight: "600",
              }}
            >
              {solicitud.name}
            </Typography>
            <div
              style={{
                width: "100%",
                flexDirection: "row",
                marginTop: 0,
                alignItems: "flex-start",
                justifyContent: "center",
                paddingTop: 5,
              }}
            >
              <Typography>Fecha</Typography>
              <FormControl sx={{ m: 1, width: "215px", mt: 3, ml: 2 }}>
                <InputLabel id="demo-simple-select-label">Mes</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="Mes"
                  defaultValue={new Date().getMonth()}
                  onChange={(e) => {
                    setYearDesde({ ...yearDesde, mes: e.target.value });
                  }}
                >
                  {mesArray.map((data) => {
                    return <MenuItem value={data.value}>{data.name}</MenuItem>;
                  })}
                </Select>
              </FormControl>
              <FormControl sx={{ m: 1, width: "215px", mt: 3, ml: 2 }}>
                <InputLabel id="demo-simple-select-label">Año</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="Año"
                  defaultValue={new Date().getFullYear()}
                  onChange={(e) => {
                    setYearDesde({ ...yearDesde, year: e.target.value });
                  }}
                >
                  {yearArray.map((data, index) => {
                    return <MenuItem value={data.value}>{data.name}</MenuItem>;
                  })}
                </Select>
              </FormControl>
            </div>

            <div
              style={{
                width: "100%",
                height: 150,
                display: "flex",
                flexDirection: "row",
                marginTop: 0,
                alignItems: "flex-start",
                justifyContent: "center",
                paddingTop: 20,
              }}
            >
              <TextField
                sx={{ m: 1, width: 100, mt: 3, ml: 2 }}
                id="outlined-basic"
                label="UF"
                variant="outlined"
                size="small"
                onKeyDown={(e) => handleUpdateNumberUF(e)}
                value={forMilesUf(uf)}
                onChange={(e) => {
                  setUf(e.target.value.replace(".", ""));
                }}
              />

              <FormControl sx={{ m: 1, width: 200, mt: 3 }}>
                <InputLabel id="demo-simple-select-label" size="small">
                  Seleccionar empresa
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={empresa}
                  label="Seleccionar empresa"
                  onChange={(e) => {
                    const busqueda = clientesReduxReport.filter(
                      (data) => data.name === e.target.value
                    );

                    setEmpresa(e.target.value);
                  }}
                  size="small"
                >
                  {names.map((data) => (
                    <MenuItem name={data.rut} key={data.id} value={data.name}>
                      {data.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <Button
                style={{
                  width: 115,
                  height: 40,
                  backgroundColor: "rgb(244, 121, 109)",
                  marginLeft: 10,
                  marginBottom: 10,
                  marginTop: 23,
                }}
                variant="contained"
                onClick={() => {
                  if (
                    Object.entries(yearDesde).length === 0 ||
                    empresa === false ||
                    uf < 1
                  ) {
                    return;
                  } else {
                    handleChange();
                  }
                }}
              >
                <p style={{ fontSize: 9 }}>Generar Rep.</p>
              </Button>
            </div>
          </>
        );
      })}
      <LoadScreen setOpenLoad={open} openLoad={open} />
      {Object.values(rows).length > 0 ? (
        <Container container>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 700 }} aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell2
                    style={{ color: "#000", textAlign: "left" }}
                    align="left"
                  >
                    Nombre empresa
                  </StyledTableCell2>

                  <StyledTableCell2
                    style={{ color: "#000", textAlign: "left" }}
                    align="left"
                  >
                    {empresaS}
                  </StyledTableCell2>
                </TableRow>
                <TableRow>
                  <StyledTableCell2
                    style={{ color: "#000", textAlign: "left" }}
                    align="left"
                  >
                    Rut empresa:
                  </StyledTableCell2>

                  <StyledTableCell2
                    style={{ color: "#000", textAlign: "left" }}
                    align="left"
                  >
                    {rut}
                  </StyledTableCell2>
                </TableRow>

                <TableRow>
                  <StyledTableCell2
                    style={{ color: "#000", textAlign: "left" }}
                    align="left"
                  >
                    {" "}
                    Fecha inicio
                  </StyledTableCell2>

                  <StyledTableCell2
                    style={{ color: "#000", textAlign: "left" }}
                    align="left"
                  >
                    {" "}
                    01-{yearDesdeS.mes < 10 ? 0 : null}
                    {yearDesdeS.mes}-{yearDesdeS.year}
                  </StyledTableCell2>
                </TableRow>
                <TableRow>
                  <StyledTableCell2
                    style={{ color: "#000", textAlign: "left" }}
                    align="left"
                  >
                    Fecha final
                  </StyledTableCell2>

                  <StyledTableCell2
                    style={{ color: "#000", textAlign: "left" }}
                    align="left"
                  >
                    {new Date(yearDesdeS.year, yearDesdeS.mes, 0).getDate()}-
                    {yearDesdeS.mes < 10 ? 0 : null}
                    {yearDesdeS.mes}-{yearDesdeS.year}
                  </StyledTableCell2>
                </TableRow>
                <TableRow>
                  <StyledTableCell2
                    style={{ color: "#000", textAlign: "left" }}
                    align="left"
                  >
                    Valor uf
                  </StyledTableCell2>

                  <StyledTableCell2
                    style={{ color: "#000", textAlign: "left" }}
                    align="left"
                  >
                    {forMiles(ufs)}
                  </StyledTableCell2>
                </TableRow>
                <TableRow>
                  <StyledTableCell2
                    style={{ color: "#000", textAlign: "left" }}
                    align="left"
                  >
                    Total de llamadas
                  </StyledTableCell2>

                  <StyledTableCell2
                    style={{ color: "#000", textAlign: "left" }}
                    align="left"
                  >
                    {forMiles(sumaTotalLlamadas)}
                  </StyledTableCell2>
                </TableRow>
                <TableRow>
                  <StyledTableCell2
                    style={{ color: "#000", textAlign: "left" }}
                    align="left"
                  >
                    Total anexos conectados
                  </StyledTableCell2>

                  <StyledTableCell2
                    style={{ color: "#000", textAlign: "left" }}
                    align="left"
                  >
                    {forMiles(anexosConectados)}
                  </StyledTableCell2>
                </TableRow>
              </TableHead>
              <TableHead>
                <TableRow>
                  <StyledTableCell style={{ backgroundColor: "#F4796D" }}>
                    Item
                  </StyledTableCell>
                  <StyledTableCell
                    align="center"
                    style={{ backgroundColor: "#F4796D" }}
                  >
                    Cantidad
                  </StyledTableCell>
                  <StyledTableCell
                    align="right"
                    style={{ backgroundColor: "#F4796D" }}
                  >
                    Total Llamadas
                  </StyledTableCell>
                  <StyledTableCell
                    align="right"
                    style={{ backgroundColor: "#F4796D" }}
                  >
                    Valor individual
                  </StyledTableCell>
                  <StyledTableCell
                    align="right"
                    style={{ backgroundColor: "#F4796D" }}
                  >
                    Valor general
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {Object.values(tarifas).map((tarifas2, index) => {
                  parseInt(tarifas2.tipo) === 1
                    ? arrSuma.push(
                        parseFloat(
                          parseFloat(tarifas2.cost) *
                            ufs *
                            parseInt(tarifas2.cantidad)
                        )
                      )
                    : arrSuma.push(
                        parseFloat(
                          parseInt(tarifas2.cost) * parseInt(tarifas2.cantidad)
                        )
                      );

                  return (
                    <StyledTableRow key={index}>
                      <StyledTableCell component="th" scope="row">
                        {tarifas2.name}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {tarifas2.cantidad}
                      </StyledTableCell>
                      <StyledTableCell align="left"></StyledTableCell>

                      <StyledTableCell align="right">
                        ${" "}
                        {parseInt(tarifas2.tipo) === 1
                          ? forMiles(Math.ceil(tarifas2.cost * ufs))
                          : forMiles(Math.ceil(tarifas2.cost))}
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        ${" "}
                        {parseInt(tarifas2.tipo) === 1
                          ? forMiles(
                              Math.ceil(
                                parseFloat(tarifas2.cost) *
                                  ufs *
                                  parseInt(tarifas2.cantidad)
                              )
                            )
                          : forMiles(
                              Math.ceil(
                                parseInt(tarifas2.cost) *
                                  parseInt(tarifas2.cantidad)
                              )
                            )}
                      </StyledTableCell>
                    </StyledTableRow>
                  );
                })}
                {rows.map((row, index) => {
                  arrSuma.push(parseFloat(row.cost) ? parseFloat(row.cost) : 0);

                  arrSumaLlamadas.push(parseInt(row.total_llamadas));
                  return (
                    <StyledTableRow key={row.name}>
                      <StyledTableCell component="th" scope="row">
                        {row.name}
                      </StyledTableCell>
                      <StyledTableCell align="center">{1}</StyledTableCell>
                      <StyledTableCell align="right">
                        {forMiles(row.total_llamadas)}
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        $ {row.cost ? forMiles(row.cost) : 0}
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        $ {row.cost ? forMiles(row.cost) : 0}
                      </StyledTableCell>
                    </StyledTableRow>
                  );
                })}
                {/* <StyledTableRow>
              <StyledTableCell
                align="left"
                style={{ background: "rgba(0,0,0,0)" }}
              >
                {" "}
              </StyledTableCell>
              <StyledTableCell align="left"> </StyledTableCell>
              <StyledTableCell align="left"> </StyledTableCell>
              <StyledTableCell align="left">Total Llamadas</StyledTableCell>
              <StyledTableCell align="right">
                {forMiles(sumaTotalLlamadas)}
              </StyledTableCell>
            </StyledTableRow> */}
                <StyledTableRow>
                  <StyledTableCell
                    align="left"
                    style={{ background: "rgba(0,0,0,0)" }}
                  ></StyledTableCell>
                  <StyledTableCell align="left"></StyledTableCell>
                  <StyledTableCell align="right"></StyledTableCell>
                  <StyledTableCell align="right">Total Neto</StyledTableCell>
                  <StyledTableCell align="right">
                    $ {forMiles(Math.ceil(sumaTotal))}
                  </StyledTableCell>
                </StyledTableRow>
                <StyledTableRow>
                  <StyledTableCell align="left"> </StyledTableCell>
                  <StyledTableCell align="left"> </StyledTableCell>
                  <StyledTableCell align="left"> </StyledTableCell>
                  <StyledTableCell align="right">IVA</StyledTableCell>
                  <StyledTableCell align="right">
                    $ {forMiles(Math.ceil(sumaTotal * 0.19))}
                  </StyledTableCell>
                </StyledTableRow>
                <StyledTableRow>
                  <StyledTableCell align="left"> </StyledTableCell>
                  <StyledTableCell align="left"> </StyledTableCell>
                  <StyledTableCell align="left"> </StyledTableCell>
                  <StyledTableCell align="right">TOTAL</StyledTableCell>
                  <StyledTableCell align="right">
                    $ {forMiles(Math.ceil(sumaTotal * 1.19))}
                  </StyledTableCell>
                </StyledTableRow>
              </TableBody>
            </Table>
          </TableContainer>

            {/*TABLA PARA EXPORTAR*/}
          <TableContainer component={Paper} style={{display:'none'}}>
            <Table
              id="tablaReporte"
              sx={{ minWidth: 700 }}
              aria-label="customized table"
            >
              <TableHead>
                <TableRow>
                  <StyledTableCell2
                    style={{ color: "#000", textAlign: "left" }}
                    align="left"
                  >
                    Nombre empresa
                  </StyledTableCell2>

                  <StyledTableCell2
                    style={{ color: "#000", textAlign: "left" }}
                    align="left"
                  >
                    {empresaS}
                  </StyledTableCell2>
                </TableRow>
                <TableRow>
                  <StyledTableCell2
                    style={{ color: "#000", textAlign: "left" }}
                    align="left"
                  >
                    Rut empresa:
                  </StyledTableCell2>

                  <StyledTableCell2
                    style={{ color: "#000", textAlign: "left" }}
                    align="left"
                  >
                    {rut}
                  </StyledTableCell2>
                </TableRow>

                <TableRow>
                  <StyledTableCell2
                    style={{ color: "#000", textAlign: "left" }}
                    align="left"
                  >
                    {" "}
                    Fecha inicio
                  </StyledTableCell2>

                  <StyledTableCell2
                    style={{ color: "#000", textAlign: "left" }}
                    align="left"
                  >
                    {" "}
                    01-{yearDesdeS.mes < 10 ? 0 : null}
                    {yearDesdeS.mes}-{yearDesdeS.year}
                  </StyledTableCell2>
                </TableRow>
                <TableRow>
                  <StyledTableCell2
                    style={{ color: "#000", textAlign: "left" }}
                    align="left"
                  >
                    Fecha final
                  </StyledTableCell2>

                  <StyledTableCell2
                    style={{ color: "#000", textAlign: "left" }}
                    align="left"
                  >
                    {new Date(yearDesdeS.year, yearDesdeS.mes, 0).getDate()}-
                    {yearDesdeS.mes < 10 ? 0 : null}
                    {yearDesdeS.mes}-{yearDesdeS.year}
                  </StyledTableCell2>
                </TableRow>
                <TableRow>
                  <StyledTableCell2
                    style={{ color: "#000", textAlign: "left" }}
                    align="left"
                  >
                    Valor uf
                  </StyledTableCell2>

                  <StyledTableCell2
                    style={{ color: "#000", textAlign: "left" }}
                    align="left"
                  >
                    {forMiles(ufs)}
                  </StyledTableCell2>
                </TableRow>
                <TableRow>
                  <StyledTableCell2
                    style={{ color: "#000", textAlign: "left" }}
                    align="left"
                  >
                    Total de llamadas
                  </StyledTableCell2>

                  <StyledTableCell2
                    style={{ color: "#000", textAlign: "left" }}
                    align="left"
                  >
                    {forMiles(sumaTotalLlamadas)}
                  </StyledTableCell2>
                </TableRow>
                <TableRow>
                  <StyledTableCell2
                    style={{ color: "#000", textAlign: "left" }}
                    align="left"
                  >
                    Total anexos conectados
                  </StyledTableCell2>

                  <StyledTableCell2
                    style={{ color: "#000", textAlign: "left" }}
                    align="left"
                  >
                    {forMiles(anexosConectados)}
                  </StyledTableCell2>
                </TableRow>
              </TableHead>
              <TableHead>
                <TableRow>
                  <StyledTableCell style={{ backgroundColor: "#F4796D" }}>
                    Item
                  </StyledTableCell>
                  <StyledTableCell
                    align="center"
                    style={{ backgroundColor: "#F4796D" }}
                  >
                    Cantidad
                  </StyledTableCell>
                  <StyledTableCell
                    align="right"
                    style={{ backgroundColor: "#F4796D" }}
                  >
                    Valor individual
                  </StyledTableCell>
                  <StyledTableCell
                    align="right"
                    style={{ backgroundColor: "#F4796D" }}
                  >
                    Valor general
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {Object.values(tarifas).map((tarifas2, index) => {
                  

                  return (
                    <StyledTableRow key={index}>
                      <StyledTableCell component="th" scope="row" style={{textAlign: 'left'}}>
                        {tarifas2.name}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {tarifas2.cantidad}
                      </StyledTableCell>
                     

                      <StyledTableCell align="right">
                        {parseInt(tarifas2.tipo) === 1
                          ? forMiles(Math.ceil(tarifas2.cost * ufs))
                          : forMiles(Math.ceil(tarifas2.cost))}
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        {parseInt(tarifas2.tipo) === 1
                          ? forMiles(
                              Math.ceil(
                                parseFloat(tarifas2.cost) *
                                  ufs *
                                  parseInt(tarifas2.cantidad)
                              )
                            )
                          : forMiles(
                              Math.ceil(
                                parseInt(tarifas2.cost) *
                                  parseInt(tarifas2.cantidad)
                              )
                            )}
                      </StyledTableCell>
                    </StyledTableRow>
                  );
                })}
                {rows.map((row, index) => {

                  return (
                    <StyledTableRow key={row.name}>
                      <StyledTableCell component="th" scope="row" style={{textAlign: 'left'}}>
                        {row.name}
                      </StyledTableCell>
                      <StyledTableCell align="center">{1}</StyledTableCell>
                     
                      <StyledTableCell align="right">
                        {row.cost ? forMiles(row.cost) : 0}
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        {row.cost ? forMiles(row.cost) : 0}
                      </StyledTableCell>
                    </StyledTableRow>
                  );
                })}
                {/* <StyledTableRow>
                  <StyledTableCell
                    align="left"
                    style={{ background: "rgba(0,0,0,0)" }}
                  >
                    {" "}
                  </StyledTableCell>
                  <StyledTableCell align="left"> </StyledTableCell>
                  <StyledTableCell align="left"> </StyledTableCell>
                  <StyledTableCell align="left">Total Llamadas</StyledTableCell>
                  <StyledTableCell align="right">
                    {forMiles(sumaTotalLlamadas)}
                  </StyledTableCell>
                </StyledTableRow> */}
                <StyledTableRow>
                  <StyledTableCell align="left"></StyledTableCell>
                  <StyledTableCell align="right"></StyledTableCell>
                  <StyledTableCell align="right">Total Neto</StyledTableCell>
                  <StyledTableCell align="right">
                    {forMiles(Math.ceil(sumaTotal))}
                  </StyledTableCell>
                </StyledTableRow>
                <StyledTableRow>
                  <StyledTableCell align="left"> </StyledTableCell>
                  <StyledTableCell align="left"> </StyledTableCell>
                  <StyledTableCell align="right">IVA</StyledTableCell>
                  <StyledTableCell align="right">
                    {forMiles(Math.ceil(sumaTotal * 0.19))}
                  </StyledTableCell>
                </StyledTableRow>
                <StyledTableRow>
                  <StyledTableCell align="left"> </StyledTableCell>
                  <StyledTableCell align="left"> </StyledTableCell>
                  <StyledTableCell align="right">TOTAL</StyledTableCell>
                  <StyledTableCell align="right">
                    {forMiles(Math.ceil(sumaTotal * 1.19))}
                  </StyledTableCell>
                </StyledTableRow>
              </TableBody>
            </Table>
          </TableContainer>
          <ReactHTMLTableToExcel
            id="test-table-xls-button"
            className="botonReporte"
            table="tablaReporte"
            filename={`${empresaS}(${yearDesdeS.mes}-${yearDesdeS.year})`}
            sheet="tablexls"
            buttonText="Descargar Excel"
            style={{
              padding: 5,
              width: 50,
              height: 100,
            }}
          />
        </Container>
      ) : null}
    </div>
  );
}

export default connect(mapStateToProps, null)(AdmGeneradorReporte);
